import React, { useEffect, useState, useRef } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
// import KeyRegCards_FPS_Cards from './KeyRegCards_FPS_Cards';

const DistributionFPS_data = async (parms) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/DistExtensionReportFps`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(parms),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};


const Distribution_FPS = ({ month, year, dist_code, afso_code }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const fpstab = useRef(null); // Use ref to scroll to this div
    const [renderContenttttt, setRenderContenttttt] = useState(null);
    const details3 = useRef(null); // Use ref to scroll to this div
    const handleFPSClick = (month, year, dist_code, afso_code, fps_id) => {
        setRenderContenttttt(null);

        setTimeout(() => {
            //   setRenderContenttttt(
            //       <KeyRegCards_FPS_Cards
            //           month={month}
            //           year={year}
            //           dist_code={dist_code}
            //           afso_code={afso_code}
            //           fps_id={fps_id}
            //       />
            //   );
        }, 10);
    };


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await DistributionFPS_data({ month, year, dist_code, afso_code });
                setTabHeading(response_data.heading);

                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (errorr) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code, afso_code]);

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && fpstab.current) {
            fpstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
            Internal Error
        </div>
    }
    if (reportData.length === 0) {
        return <div class="mainhead" align="center">
            No data found
        </div>
    }


    return (
        <>
            <table ref={fpstab} align="center" width="50%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={9}> {tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>FPS</th>
                        <th rowSpan={3}>Start Date</th>
                        <th rowSpan={3}>End Date</th>

                    </tr>


                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.fps_id}>
                            <td  style={{ textAlign: 'center' }} >{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>

                                {item.fps_id}
                            </td>
                            <td style={{ textAlign: 'right' }}>{item.startdate}</td>

                            <td style={{ textAlign: 'right' }}>{item.endDate}</td>

                        </tr>
                    ))}

                </tbody>
            </table>
            <br /><br />
            <br/>
            <div id='detailsRR' ref={details3}>{renderContenttttt}</div>

        </>
    );
};

export default Distribution_FPS;
